var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotepadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.73 53.8072C55.5162 52.1471 61.8575 50.7776 67.7541 49.6985C74.5369 48.4572 81.4641 47.4663 88.5356 46.7256C90.3989 46.5304 92.2679 47.0358 93.8026 48.1498L122.136 68.7161C123.614 69.7892 124.69 71.36 125.18 73.1621L125.38 73.9073C127.086 80.3327 128.883 89.0719 130.773 100.125L131.162 102.427C132.713 111.703 133.839 119.749 134.542 126.564L134.603 127.162C134.996 131.081 132.622 134.727 128.971 135.808C119.893 138.498 109.18 140.985 96.8327 143.269L95.9263 143.436C83.7687 145.66 73.4516 147.068 64.9749 147.659L64.4247 147.696C60.7101 147.941 57.3435 145.436 56.3763 141.705C53.2674 129.714 50.3661 115.791 47.6722 99.9354L47.3922 98.2757C45.044 84.256 43.503 72.4604 42.7693 62.8887L42.7271 62.3282C42.4371 58.4096 44.8925 54.8495 48.5371 53.8571L48.73 53.8072Z",
    fill: "white",
    stroke: "#7B828E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10910_159680",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 45,
    width: 95,
    height: 104
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.73 53.8072C55.5162 52.1471 61.8575 50.7776 67.7541 49.6985C74.5369 48.4572 81.4641 47.4663 88.5356 46.7256C90.3989 46.5304 92.2679 47.0358 93.8026 48.1498L122.136 68.7161C123.614 69.7892 124.69 71.36 125.18 73.1621L125.38 73.9073C127.086 80.3327 128.883 89.0719 130.773 100.125L131.162 102.427C132.713 111.703 133.839 119.749 134.542 126.564L134.603 127.162C134.996 131.081 132.622 134.727 128.971 135.808C119.893 138.498 109.18 140.985 96.8327 143.269L95.9263 143.436C83.7687 145.66 73.4516 147.068 64.9749 147.659L64.4247 147.696C60.7101 147.941 57.3435 145.436 56.3763 141.705C53.2674 129.714 50.3661 115.791 47.6722 99.9354L47.3922 98.2757C45.044 84.256 43.503 72.4604 42.7693 62.8887L42.7271 62.3282C42.4371 58.4096 44.8925 54.8495 48.5371 53.8571L48.73 53.8072Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10910_159680)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8478 46.3618L123.488 70.066L101.328 74.1211C98.7764 74.5881 96.3429 72.8197 95.8929 70.1712L91.8478 46.3618Z",
    fill: "white",
    stroke: "#7B828E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0818 88.7287C67.0818 88.7287 72.5086 83.3034 76.4833 86.3347C78.0648 87.5409 81.274 90.2783 74.9752 103.184C71.4012 110.506 77.9584 112.64 81.8682 107.294C87.5332 99.5473 89.6115 94.3297 96.4609 95.9553C102.879 97.4786 104.613 109.094 99.6485 114.717C94.6844 120.34 87.1221 114.316 90.6735 108.278C94.2249 102.24 100.372 98.7211 109.539 100.007",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0818 88.7287C67.0818 88.7287 72.5086 83.3034 76.4833 86.3347C78.0648 87.5409 81.274 90.2783 74.9752 103.184C71.4012 110.506 77.9584 112.64 81.8682 107.294C87.5332 99.5473 89.6115 94.3297 96.4609 95.9553C102.879 97.4786 104.613 109.094 99.6485 114.717C94.6844 120.34 87.1221 114.316 90.6735 108.278C94.2249 102.24 100.372 98.7211 109.539 100.007",
    stroke: "#7B828E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.199 85.6599L152.996 89.3026C145.895 101.002 139.726 110.745 134.488 118.532L134.169 119.006C128.263 127.76 122.021 136.269 115.443 144.534C113.808 146.588 111.902 148.393 109.783 149.896L102.498 155.062C101.429 155.821 99.9689 155.536 99.2379 154.426C98.8573 153.847 98.7349 153.127 98.9021 152.449L101.088 143.579C101.724 140.997 102.707 138.521 104.008 136.224C109.247 126.973 114.816 117.976 120.717 109.23L121.687 107.798C127.389 99.422 134.732 89.2611 143.717 77.3157C146.015 74.2607 150.215 73.6082 153.274 75.8312C156.333 78.0542 157.179 82.374 155.199 85.6599Z",
    fill: "white",
    stroke: "#7B828E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.97 18L78.63 21.73",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 23.97L82.77 24.63",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.53 32.5L79.87 28.78",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26.53L75.73 25.87",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.77 24.63C82.31 24.71 81.83 24.7 81.37 24.6C80.91 24.5 80.48 24.31 80.09 24.04C79.71 23.77 79.38 23.43 79.13 23.03C78.88 22.63 78.71 22.19 78.63 21.73C78.71 22.19 78.7 22.67 78.6 23.13C78.5 23.59 78.31 24.02 78.04 24.41C77.77 24.8 77.43 25.12 77.03 25.38C76.63 25.63 76.19 25.8 75.73 25.89C76.19 25.81 76.67 25.82 77.13 25.92C77.59 26.02 78.02 26.21 78.41 26.48C78.8 26.75 79.12 27.09 79.38 27.49C79.63 27.89 79.8 28.33 79.88 28.79C79.8 28.33 79.81 27.85 79.91 27.39C80.01 26.93 80.2 26.5 80.47 26.11C80.74 25.73 81.08 25.4 81.48 25.14C81.88 24.89 82.32 24.72 82.78 24.63H82.77Z",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.98 172.659C142.29 172.659 144.98 169.969 144.98 166.659C144.98 163.349 142.29 160.659 138.98 160.659C135.67 160.659 132.98 163.349 132.98 166.659C132.98 169.969 135.67 172.659 138.98 172.659Z",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.77 36.0098L168 43.0798L173.36 42.1298L171.59 49.1998",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepadImg);
export default __webpack_public_path__ + "static/media/NotepadImg.320b79d34e9b90ab6a87cded0f084d37.svg";
export { ForwardRef as ReactComponent };